<div class="Assignment page-holder bg-gray-100">
    <div class="container-fluid px-lg-4 px-xl-5 min-w-viewport">
        <!-- Page Header-->
        <div class="page-header d-flex justify-content-between align-items-center">
            <h1 class="page-heading">{{formName}}</h1>
        </div>

        <div class="row mb-5">
            <div class="form-group">
                <div class="col-md-12 mb-4">
                    <div class="card h-100">
                        <div class="card-header">
                            <h4 class="card-heading">{{facilityName}}</h4>
                        </div>
                        <div class="card-body">
                            <div class="py-2">Schedule a form Inspection</div>
                            <mat-button-toggle-group name="fontStyle" aria-label="Font Style">
                                <mat-button-toggle value="never" (change)="onValChange($event.value)">Once
                                </mat-button-toggle>
                                <mat-button-toggle value="daily" (change)="onValChange($event.value)">Daily
                                </mat-button-toggle>
                                <mat-button-toggle value="weekly" (change)="onValChange($event.value)">Weekly
                                </mat-button-toggle>
                                <mat-button-toggle value="monthly" (change)="onValChange($event.value)">Monthly
                                </mat-button-toggle>
                                <mat-button-toggle value="yearly" (change)="onValChange($event.value)">Yearly
                                </mat-button-toggle>
                            </mat-button-toggle-group>
                            <div class="py-4" *ngIf="recurrenceDuration=='never'">
                                <label class="col-md-1 form-label">Due by:</label>
                                <input type="date" id="fromDate" name="From Date">
                            </div>
                            <div *ngIf="recurrenceDuration=='daily'">
                                <div class="py-5">
                                    <div class="d-flex">
                                        <span class="me-2">Inspection frequency Every</span>
                                        <div class="col-md-2 col-lg-1 me-2">
                                            <input class="form-control col-md-3" type="text"
                                                [(ngModel)]="repeatNoofDays">
                                        </div>
                                        <span class="me-2">Day/Days,</span>
                                        <label class="me-1" for="dayTime">At</label>
                                        <div class="col-md-2 col-lg-1 me-2">
                                            <input class="form-control col-md-3" type="time" id="dayTime" name="dayTime">
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="recurrenceDuration=='weekly'">
                                <div class="py-5">
                                    <div class="d-flex">
                                        <span class="me-2">Inspection frequency every</span>
                                        <div class="col-md-2 col-lg-1 me-2">
                                            <input class="form-control" type="text" [(ngModel)]="repeatNoofWeeks">
                                        </div>
                                        <span class="">Week/Weeks</span>
                                        <label class="me-1" for="weekTime">At</label>
                                        <div class="col-md-2 col-lg-1 me-2">
                                            <input class="form-control col-md-3" type="time" id="weekTime" name="weekTime">
                                        </div>
                                    </div>
                                    <div class="col-md-9 d-flex">
                                        <div class="form-check mb-4 me-2" *ngFor="let day of daysOfWeek">
                                            <input class="form-check-input" id="customCheck1" type="checkbox">
                                            <label class="custom-control-label" for="customCheck1">{{day}}</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="recurrenceDuration=='monthly'">
                                <div class="py-5">
                                    <div class="d-flex">
                                        <span class="me-2">Inspection frequency every</span>
                                        <div class="col-md-2 col-lg-1 me-2">
                                            <input class="form-control" type="text" [(ngModel)]="repeatNoOfMonths">
                                        </div>
                                        <span class="">Month/Months</span>
                                        <label class="me-1" for="monthTime">At</label>
                                        <div class="col-md-2 col-lg-1 me-2">
                                            <input class="form-control col-md-3" type="time" id="monthTime" name="monthTime">
                                        </div>
                                    </div>
                                    <div class="mt-2">
                                        <select class="form-control" name="account" [(ngModel)]="selectedDay">
                                            <option *ngFor="let day of daysOfMonth" [value]="day">{{day}}</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="recurrenceDuration=='yearly'">
                                Yearly
                            </div>
                            <!-- <div class="col-md-9">
                        <div class="form-check">
                          <input class="form-check-input" id="customRadioInline1" type="radio" name="customRadioInline1">
                          <label class="custom-control-label" for="customRadioInline1">Never Stop</label>
                        </div>
                        <div class="form-check">
                          <input class="form-check-input" id="customRadioInline2" type="radio" name="customRadioInline1">
                          <label class="custom-control-label" for="customRadioInline2">Run until a specific date
                            <input type="date" id="fromDate" name="From Date">
                          </label>
                        </div>
                        <div class="form-check">
                            <input class="form-check-input" id="customRadioInline2" type="radio" name="customRadioInline1">
                            <label class="custom-control-label" for="customRadioInline2">Run until it reaches </label>
                          </div>
                      </div> -->
                            <div *ngIf="recurrenceDuration!=''" class="col-12">
                                <button class="btn btn-primary" type="submit" (click)="assign()">Submit</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <div class="col-md-2 mb-4" *ngFor="let row of submissionsData | freetextSearch: query">
            <div class="card h-100">
              <div  class="card-body cursor-pointer">
                <h6 class="card-heading mb-1">{{row.facilityName}}</h6> 
              </div>
            </div>
        </div> -->
        </div>
    </div>
    <app-footer class="footer-w"></app-footer>
</div>
